// SICARG — Interpreta montos tal como los pega/escribe el agente.
// Acepta: "1234", "1234.56" (formato que ya se aceptaba), "1234,56",
// "6.396.728,00" (Access: punto de miles + coma decimal) y "1,234.56".
// Regla: si hay ambos separadores, el último es el decimal; un separador
// repetido es de miles (en grupos de 3); un único punto o coma es decimal.
// Devuelve un Number (2 decimales) o null si el texto no es un monto válido.

// Parte entera: solo dígitos, o grupos de 3 con un único tipo de separador de miles.
const INTEGER_PART = /^(\d+|\d{1,3}(\.\d{3})+|\d{1,3}(,\d{3})+)?$/;

export const parseAmount = raw => {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : null;

  const text = String(raw).replace(/[$\s]/g, '');
  if (!text || !/^[\d.,]+$/.test(text)) return null;

  const lastDot = text.lastIndexOf('.');
  const lastComma = text.lastIndexOf(',');
  const dots = (text.match(/\./g) || []).length;
  const commas = (text.match(/,/g) || []).length;

  let decimalSep = null;
  if (lastDot !== -1 && lastComma !== -1) {
    decimalSep = lastDot > lastComma ? '.' : ',';
  } else if (dots === 1) {
    decimalSep = '.';
  } else if (commas === 1) {
    decimalSep = ',';
  }

  let integerRaw = text;
  let decimalPart = '';
  if (decimalSep) {
    const idx = text.lastIndexOf(decimalSep);
    integerRaw = text.slice(0, idx);
    decimalPart = text.slice(idx + 1);
    if (!/^\d*$/.test(decimalPart)) return null;
  }
  if (!INTEGER_PART.test(integerRaw)) return null;

  const integerPart = integerRaw.replace(/[.,]/g, '') || '0';
  const value = Number(`${integerPart}.${decimalPart || '0'}`);
  return Number.isFinite(value) ? Math.round(value * 100) / 100 : null;
};

// Texto vacío no es un error de formato: el campo simplemente está sin cargar.
export const isAmountInvalid = raw =>
  String(raw ?? '').trim() !== '' && parseAmount(raw) === null;

// Vista previa legible del valor interpretado ("$ 6.396.728,00").
export const formatAmountPreview = raw => {
  const value = parseAmount(raw);
  if (value === null) return '';
  return `$ ${value.toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
